<template>
  <img src="@/assets/images/ilustraciones/img-empresas-anter_empresa-1.svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
</template>
